export default "__VITE_ASSET__ZoRi3u5X__"